<template>
  <div class="business-income-table">
    <div class="default-table" style="padding: 2px 2px">
      <MlPageTable :show-slot='loadingStatus'
                   :all-columns='userColumns'
                   :table-name='tableName'
                   :data-list='dataList'
                   :limit.sync='pagingData.page_size'
                   :page.sync='pagingData.current_page'
                   :total.sync='pagingData.total'
                   :show-index='true'
                   :height-value="height"
                   highlight-current-row
                   @sort-change='changeTableSort'
                   @getList='initList'
                   @select="handleSelectRow"
                   @selection-change="handleSelectionChange"
                   @select-all="HandleSelectAll"
                   ref="elAdIncomeTable"
                   stripe
                   :border="true">
        <el-table-column slot="first-column" type="selection" width="55"/>
        <el-table-column
            slot='customer_id'
            prop="customer_name"
            label="客户名称"
            header-align="center"
            align="left"
            sortable="custom"
            width="200"
        >
          <template slot-scope="scope">
            <template v-if="readonly">
              {{ scope.row.customer_name }}
            </template>
            <template v-else>
              <el-link class="table-link" type="primary" @click="goDetail(scope.row)">
                              <span class="flag-span" style="background-color: #FF5722;"
                                    v-show="scope.row.order_type === 'strike' || scope.row.order_type === '冲账类型'">冲</span>
                <span class="flag-span" style="background-color: #bd06c5;"
                      v-show="scope.row.is_new_customer === 'Y'">新客</span>
                <span v-show="scope.row.is_mark==1" class="flag-span"
                      style="background-color: #ff3176;">全案  {{
                    scope.row.pid === 0 ? '主' : '子'
                  }}
                              </span>
                <span v-show="scope.row.project_type==3" class="flag-span"
                      style="background-color: #ff3176;">普客 子
                              </span>
                <span>{{ scope.row.customer_name }}</span>
              </el-link>
            </template>
          </template>
        </el-table-column>

        <el-table-column prop="sale_id"
                         label="销售"
                         header-align="center"
                         align="center"
                         sortable="custom"
                         width="120"
                         slot="sale_id">
          <template slot-scope="{row}">
            <!--              <el-link>{{row.sale_name||''}}</el-link>-->
            <link-user :name="row.sale_name" :id="row.sale_id"></link-user>
          </template>
        </el-table-column>
        <el-table-column prop="is_confirm"
                         label="确认状态"
                         header-align="center"
                         align="center"
                         width="120"
                         slot="is_confirm">
          <template slot-scope="{row}">
            <el-tag v-if="row.is_confirm === 'Y'" type="success" size="mini">已确认</el-tag>
            <b v-else>未确认</b>          </template>
        </el-table-column>
        <el-table-column
            v-if="hasOptColumn&&needOperate"
            key="操作项"
            label="操作项"
            slot="handle-column"
            header-align="center"
            align="left"
            width="160"
            fixed="right"
        >
          <template slot-scope="scope">
            <AdOptColumn :row="scope.row" :row-index="scope.$index"
                         @refreshOrderList="refreshOrderList"
                         @goDetail="goDetail"
                         @goView="goView"
            />
          </template>
        </el-table-column>
        <div slot="footer">
          <div class="bottom-bar">
            <el-button size="mini" @click="clearData" :disabled="previewOrderTotal===0">清空已选
            </el-button>
            <div
                style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;display: flex;align-items: center;">
              <div style="font-weight: bold;display: flex">
                  <span style="margin-right: 10px">总含税收入：
                    <span class="money" style="font-size: 1.2rem">{{
                        moneyFormat(paymentAccountTotal)
                      }}（{{ moneyFormat(total_amount) }}）</span>
                  </span>
              </div>
            </div>
            <div
                style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;display: flex;align-items: center;">
              <div style="font-weight: bold;display: flex">
                  <span style="margin-right: 10px">总广告收入：
                    <span class="money" style="font-size: 1.2rem">{{
                        moneyFormat(advRevenueTotal)
                      }}（{{ moneyFormat(adv_total_amount) }}）</span>
                  </span>
              </div>
            </div>
            <div
                style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;display: flex;align-items: center;">
              <div style="font-weight: bold;display: flex">
                  <span style="margin-right: 10px">总执行价：
                    <span class="money" style="font-size: 1.2rem">{{
                        moneyFormat(execPriceTotal)
                      }}（{{ moneyFormat(exec_total_amount) }}）</span>
                  </span>
              </div>
            </div>
          </div>
        </div>
      </MlPageTable>

    </div>

  </div>
</template>

<script>
import AdOptColumn from "@/views/adOrder/components/AdOptColumn";
import { getBusinessIncomeAssistantList } from "@/api/incomeSummary";
import MlPageTable from '@/components/MSettingColumn/MlPageTable.vue'
import {module_config} from '@/components/MSettingColumn/index.js'
import defaultColumns from './columns.json'
import LinkUser from "@/components/LinkUser";

export default {
  name: "BusinessIncomeTable",
  components: {
    LinkUser,
    AdOptColumn,
    MlPageTable
  },
  props: {
    readonly: Boolean,
    selectedData: {
      type: Array,
      default() {
        return []
      }
    },
    needOperate: {
      type: Boolean,
      default() {
        return true
      }
    },
    queryParams: {
      type: Object
    },
    height: {type: [String, Number], default: "auto"},
  },
  computed: {
    searchCondition: {
      get() {
        return this.queryParams
      },
      set(val) {
        this.$emit('queryParams', val)

      }
    },
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    //计算总含税收入
    paymentAccountTotal() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.payment_account / 1
      })
      return total
    },
    previewOrderTotal() {
      return this.selectedData.length
    },
    // 总广告收入
    advRevenueTotal() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.adv_revenue / 1
      })
      return total
    },
    // 总执行价
    execPriceTotal() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.exec_price / 1
      })
      return total
    },
    hasOptColumn() {
      if (this.readonly) {
        return false
      }
      return this.userAuth.can_exec_adv_order || this.userAuth.strike_balance_but || this.userAuth.option_delete_adv_order || this.userAuth.option_undo_adv_order || this.userAuth.can_create_adv_order || this.userAuth.can_update_adv_order;
    }
  },
  created() {
    // this.getTableThead()
  },
  mounted() {
    // this.initList()
  },
  data() {
    return {
      tableRef: 'elAdIncomeTable',
      // 表格列表数据
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20,
        current_page: 1,
        // offset: 0
      },
      // 分页的offset,序号列使用
      offset: 0,
      columns: [],
      columnsExclude: [],//循环排除，特定样式
      loadingStatus: false,
      // searchCondition: {},
      sum_amount: 0,
      total_amount: 0,
      adv_total_amount: 0,
      exec_total_amount: 0,
      tableName: 'business_income_table',
      editableCols: [],
      menuList: {
        edit: false,
        log: false,
        del: false,
        copy: false
      },
      userColumns: defaultColumns
    }
  },
  watch: {
    searchCondition: {
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.initList(true)
        })
      }
    }
  },
  methods: {
    //清空选中
    handleClearSelection() {
      if (this.$refs["elAdIncomeTable"])
        this.$refs["elAdIncomeTable"].clearSelection()
    },
    changeTableSort({prop, order}) {
      // let orderSort = {}
      // if (order) {
      //   orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      // }
      this.searchCondition.orderBy = `\`${prop}\` ${order === 'descending' ? 'desc' : 'asc'}`
      this.initList()
    },
    clearData() {
      this.$emit('clearData')
    },
    // 渲染选中
    toggleSelection() {
      const data = this.dataList ? this.dataList : [];

      this.$nextTick(function () {
        data.forEach(row => {
          if (this.selectedData.findIndex(value => value.id === row.id) > -1) {
            this.switchRowSelection(row, true)
          }
        });
      });
    },
    switchRowSelection(row, bool) {
      this.$refs[this.tableRef].toggleRowSelection(row, bool)
    },
    //当选择项发生变化时会触发该事件
    HandleSelectAll(selection) {
      // console.log(selection)
      if (selection.length === 0) {
        //取消全选
        // console.log('取消全选')
        // 取消的数据对象 dataList
        this.dataList.forEach((row) => {
          let index = this.selectedData.findIndex(value => value.id === row.id)
          if (index > -1)
            this.selectedData.splice(index, 1)
        })

      }
    },
    // // 行选中、取消选中
    handleSelectRow(selection, row) {
      // console.log('行选中、取消选中:'+row.id)
      if (selection.indexOf(row) === -1) {
        //row 取消选中
        // console.log('取消选中')
        let index = this.selectedData.findIndex(value => value.id === row.id)
        // this.$notify.info(`取消第${index}行`)
        if (index > -1)
          this.selectedData.splice(index, 1)
      }
    },
    handleCancelSelect(row) {
      let index = this.selectedData.findIndex(value => value.id === row.id)
      // this.$notify.info(`取消第${index}行`)
      if (index > -1) {
        let tbRow = this.dataList.find(value => value.id === row.id)
        this.switchRowSelection(tbRow, false)
        this.selectedData.splice(index, 1)
      }
    },

    init() {
      this.initList()
    },
    // 勾选事件
    handleSelectionChange(selection) {
      this.selectList = selection
      this.$emit('handleSelectionChange', selection)
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2)
    },
    // 处理搜索条件
    handleSearchCondition() {
      return this.searchCondition
      // return filterSearchCondition(this.searchCondition)
    },
    async initList(isSearch = false) {
      if (isSearch) {
        this.clearData()
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, {page: this.pagingData.current_page, per_page: this.pagingData.page_size})
      this.loadingStatus = true
      const {success, model} = await getBusinessIncomeAssistantList(searchCondition);
      this.loadingStatus = false
      if (!success) {
        return;
      }
      const {data, total, current_page, per_page, sum_amount, adv_amount_total, exec_amount_total} = model
      // this.$nextTick(() => {
      this.dataList = data
      this.toggleSelection()
      // })
      this.pagingData.total = total
      this.offset = (current_page - 1) * per_page
      // 合计含税收入
      this.total_amount = sum_amount
      // 合计广告收入
      this.adv_total_amount = adv_amount_total
      // 合计执行价
      this.exec_total_amount = exec_amount_total
    },
    //表头
    async getTableThead() {
      this.columns = [];
      let tableCols = module_config.BUSINESS_INCOME_TABLE.defaultColumns
      this.userColumns = [...tableCols]
      this.$emit('tableColumns', this.userColumns)

    },
    refreshOrderList() {
      this.$emit('refreshOrderList')
    },
    goDetail(row) {
      this.$emit('goDetail', row)
    },

    goView(row) {
      this.$emit('goDetail', row)
    },
  }
}
</script>

<style lang="scss" scoped>
.business-income-table {
  height: 100%;

  .default-table {
    height: 100%;
    //width: 98%;
  }

  .page-footer {
    height: 50px;
    width: 100%;
    position: fixed;
    bottom: 1px;
    background-color: #FFFFFF;
    opacity: 0.9;
    z-index: 999;
  }

  .bottom-bar {
    width: 100%;
    /*margin-top: 10px;*/
    text-align: left !important;
    padding: 10px 10px 0 1px;
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    /*position: fixed;bottom: 1px;*/
    /*background: #FFFFFF;*/
    /*z-index: 99999;*/
    /*opacity: 0.75;*/
  }

  .table-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .el-link--inner {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      span:last-child {
        margin-left: 2px;
      }
    }

    .flag-span {
      color: #FFF !important;
      padding: 2px 4px;
      border-radius: 2px;
      cursor: pointer;
      display: inline-block;
      font-size: 12px;
      line-height: 1;
    }

    .flag-span + .flag-span {
      margin-left: 2px;
    }


  }
}


</style>
